// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3pwx4","friends":"style_friends__2rY8x","amount":"style_amount__3Uk9c","updates":"style_updates__nx1HB"};